import PostsAdapter from './base';

export default class FeedEntry extends PostsAdapter {
  modelNamePlural = 'feedEntries';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('feedentries', 'myfeed')
      .toLowerCase();
  }
}
